import { Head, Link } from '@inertiajs/react'
import Form from './form'
import type { DeviceType } from './types'
import {ArrowLeft} from "lucide-react";

interface NewProps {
  device: DeviceType
  communities: {
    id: string
    name: string
  }[]
}

export default function New({ device, communities }: NewProps) {
  return (
    <>
      <Head title="New device" />

      <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
              <Link href="/admin/categories">
                  <button className="rounded-lg border border-border p-2 text-foreground hover:bg-secondary transition-colors">
                      <ArrowLeft className="h-5 w-5" />
                  </button>
              </Link>
              <div>
                  <h1 className="text-3xl font-bold text-foreground">Create New Category</h1>
                  <p className="text-sm text-muted-foreground">Add a new taxpayer category to the system</p>
              </div>
          </div>
      </div>

      <div className="mx-auto md:w-2/3 w-full px-8 pt-8">

        <Form
          device={device}
          communities={communities}
          method="post"
          action="/system/devices"
          submitText="Create Device"
        />

        <Link
          href="/devices"
          className="ml-2 rounded-lg py-3 px-5 bg-gray-100 inline-block font-medium"
        >
          Back to devices
        </Link>
      </div>
    </>
  )
}
